import { Component, Input, OnInit } from '@angular/core';
import { DisplaySetting } from 'src/app/model';
import { ShamalFooterLinks, HMTFooterLinks, OSPFooterLinks } from 'src/app/model/model';
import { AppContext } from 'src/app/services/app-context.service';

@Component({
  selector: 'travel-ui-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  @Input()
  displaySetting?: DisplaySetting;

  reckitFooterLogo = "https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Reckit/reckit-footer-logo.webp";

  shamalGroupFooterLinks: ShamalFooterLinks = {
    company: [
      { text: 'About Us', link: 'https://www.shamaltravels.com/about-us/' },
      { text: 'Contact Us', link: 'https://www.shamaltravels.com/contact-us/' },
      { text: 'Team', link: 'https://www.shamaltravels.com/team/' },
      { text: 'Our Partners', link: 'https://www.shamaltravels.com/our-partners/' },
      { text: 'Terms & Conditions', link: 'https://www.shamaltravels.com/term-and-condition/' },
      { text: 'Privacy Policy', link: 'https://www.shamaltravels.com/privacy-policy/' },
      { text: 'Data Protection', link: 'https://www.shamaltravels.com/data-protection/' },
      { text: 'Corporate Profile', link: 'https://ugc.production.linktr.ee/6f780388-6451-4a65-9afc-a295c84164d4_Shamal-Travels-Company-Profile-min.pdf' }
    ],
    media: [
      { text: 'In the Press', link: 'https://www.shamaltravels.com/blog/in-the-press/' },
      { text: 'Brochures', link: 'https://www.shamaltravels.com/brochures/' },
      { text: 'Social Media', link: 'https://www.shamaltravels.com/social-media/' }
    ],
    blog: [
      { text: 'Blog', link: 'https://www.shamaltravels.com/blog/' },
      { text: 'Inspiration', link: 'https://www.shamaltravels.com/blog/inspiration/' },
      { text: 'Shamal Out There!', link: 'https://www.shamaltravels.com/blog/shamal-out-there/' },
      { text: 'Tips & Tricks', link: 'https://www.shamaltravels.com/blog/tips-tricks/' }
    ],
    socialMedia: []
  }

  hostMyTripsFooterLinks: HMTFooterLinks = {
    company: [
      { text: 'About Us', link: `${window.location.origin}` + '/policies/about-us' },
      { text: 'Refund Policy', link: `${window.location.origin}` + '/policies/refund-policy' },
      { text: 'Terms & Conditions', link: `${window.location.origin}` + '/policies/terms-of-service' },
      { text: 'Privacy Policy', link: `${window.location.origin}` + '/policies/privacy-policy' },
    ],
    blog: [
      { text: 'Blog', link: 'https://blog.hostmytrips.com/' }
    ],
    villas: [
      { text: 'Villas', link: '/hotels/villas' }
    ],
    socialMedia: []
  }

  onStopParkingFooterLinks: OSPFooterLinks = {
    company: [
      { text: 'About Us', link: "https://onestopparking.com/about-us?utm_source=referral&utm_medium=zentrum&utm_campaign=hotels" },
      { text: 'Refund Policy', link: "https://onestopparking.com/refund-policy?utm_source=referral&utm_medium=zentrum&utm_campaign=hotels" },
      { text: 'Terms & Conditions', link: "https://onestopparking.com/terms-and-conditions?utm_source=referral&utm_medium=zentrum&utm_campaign=hotels" },
      { text: 'Privacy Policy', link: "https://onestopparking.com/privacy-policy?utm_source=referral&utm_medium=zentrum&utm_campaign=hotels" },
    ],
    blog: [
      { text: 'Blog', link: "https://blog.onestopparking.com/?utm_source=referral&utm_medium=zentrum&utm_campaign=hotels" }
    ],
    airportParking: [
      { text: 'Airport Parking', link: 'https://onestopparking.com/?utm_source=referral&utm_medium=zentrum&utm_campaign=hotels' }
    ],
    socialMedia: []
  }

  public footermenus: any;

  constructor(public appContext: AppContext) {
    setTimeout(() => {
      if (this.appContext.siteName == 'ShamalGroup') {
        this.shamalGroupFooterLinks = this.shamalGroupFooterLinks
        this.shamalGroupFooterLinks.socialMedia = [
          { icon: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ShamalGroup/SocialMediaIcons/Social+Media+Icons-02.png', link: this.displaySetting?.footer.facebookHref },
          { icon: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ShamalGroup/SocialMediaIcons/Social+Media+Icons-05.png', link: this.displaySetting?.footer.instagramHref },
          { icon: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ShamalGroup/SocialMediaIcons/Social+Media+Icons-03.png', link: this.displaySetting?.footer.linkedInHref },
          { icon: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ShamalGroup/SocialMediaIcons/Social+Media+Icons-04.png', link: this.displaySetting?.footer.youtubeHref },
          { icon: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ShamalGroup/SocialMediaIcons/Social+Media+Icons-01.png', link: this.displaySetting?.footer.tiktokHref },
        ]
      } else if (this.appContext.siteName == 'HostMyTrips') {
        this.hostMyTripsFooterLinks.socialMedia = [
          { icon: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Host-My-Trips/SocialMediaIcons/facebook.png', link: this.displaySetting?.footer.facebookHref },
          { icon: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Host-My-Trips/SocialMediaIcons/instagram.png', link: this.displaySetting?.footer.instagramHref },
          { icon: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Host-My-Trips/SocialMediaIcons/linkedin.png', link: this.displaySetting?.footer.linkedInHref },
          { icon: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Host-My-Trips/SocialMediaIcons/youtube.png', link: this.displaySetting?.footer.youtubeHref },
          { icon: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Host-My-Trips/SocialMediaIcons/twitterr.png', link: this.displaySetting?.footer.twitterHref },
        ]
      } else if (this.appContext.siteName == 'OneStopParking') {
        this.onStopParkingFooterLinks.socialMedia = [
          { icon: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Host-My-Trips/SocialMediaIcons/facebook.png', link: this.displaySetting?.footer.facebookHref },
          { icon: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Host-My-Trips/SocialMediaIcons/instagram.png', link: this.displaySetting?.footer.instagramHref },
          { icon: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Host-My-Trips/SocialMediaIcons/twitterr.png', link: this.displaySetting?.footer.twitterHref },
        ]
      }
      else {
        this.footermenus = this.displaySetting?.footer.links;
      }
    }, 2000);
  }
  ngOnInit() {
    setTimeout(() => { }, 1000);
  }
}
